import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { ActivitySummaryDto } from './activity-summary.dto'
import { ClassLevelSummaryDto } from './class-level-summary.dto'
import { SubjectExternalSummaryDto } from './subject-external-summary.dto'

export class TeachingAssignmentResponseDto {
  @ApiProperty({ type: 'string' })
  id!: string
  @ApiProperty({ type: 'string' })
  activityId!: string
  @ApiProperty({ type: 'string', format: 'uuid' })
  teachingId!: string
  @ApiProperty({ type: 'string' })
  subjectExternalId!: string
  @ApiProperty({ type: 'string' })
  classLevelExternalId!: string
  @ApiProperty({ type: 'string', description: "ID de l'établissement" })
  establishmentId!: string
  @ApiPropertyOptional({ type: 'string', nullable: true })
  schoolYearId!: string | null
  @ApiPropertyOptional({ type: 'string', nullable: true })
  schoolYearCode!: string | null
  @ApiPropertyOptional({ type: 'string', format: 'date-time', nullable: true })
  availableFrom!: Date | string | null
  @ApiPropertyOptional({ type: 'string', format: 'date-time', nullable: true })
  dueAt!: Date | string | null
  @ApiPropertyOptional({ type: Number, nullable: true })
  maxAttempts!: number | null
  @ApiProperty({ type: Boolean })
  showSolutions!: boolean
  @ApiProperty({ type: Boolean })
  randomizeOrder!: boolean
  @ApiProperty({ type: Boolean })
  isVisible!: boolean
  @ApiProperty({ type: 'string', format: 'date-time' })
  createdAt!: Date
  @ApiProperty({ type: 'string', format: 'date-time' })
  updatedAt!: Date

  @ApiPropertyOptional({ type: () => ActivitySummaryDto })
  activity?: ActivitySummaryDto
  @ApiPropertyOptional({ type: () => SubjectExternalSummaryDto })
  subjectExternal?: SubjectExternalSummaryDto
  @ApiPropertyOptional({ type: () => ClassLevelSummaryDto })
  classLevel?: ClassLevelSummaryDto
  @ApiPropertyOptional({
    description: 'Capabilities calculés',
    type: 'object',
    additionalProperties: true,
  })
  capabilities?: Record<string, boolean>
}
